import apiClient from './client';

export const campaignsAPI = {
  getAll: (params) => apiClient.get('/campaigns', { params }),
  get: (id) => apiClient.get(`/campaigns/${id}`),
  getOne: (id) => apiClient.get(`/campaigns/${id}`),
  // Lite: campaign metadata + creator list only (no content dedup) — fast, won't time out
  getLite: (id) => apiClient.get(`/campaigns/${id}`, { params: { lite: 'true' } }),
  getFullData: (id) => apiClient.get(`/campaigns/${id}`),
  create: (data) => apiClient.post('/campaigns', data),
  update: (id, data) => apiClient.put(`/campaigns/${id}`, data),
  // Archive/unarchive a campaign; pass { archived, archivePortals } to also archive its scoped portals
  archive: (id, data) => apiClient.post(`/campaigns/${id}/archive`, data),
  delete: (id) => apiClient.delete(`/campaigns/${id}`),
  addInfluencer: (campaignId, data) => apiClient.post(`/campaigns/${campaignId}/influencers`, data),
  // Bulk add creators to campaign - needs longer timeout for external API fetches
  bulkAddCreators: (campaignId, creators) => apiClient.post(`/campaigns/${campaignId}/creators/bulk`, { creators }, { timeout: 120000 }),
};
